var _path;
const _excluded = ["title", "titleId"],
  _excluded2 = ["title", "titleId"],
  _excluded3 = ["className", "color", "size", "pointer"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef, memo } from "react";
import { hooks } from '@approvalmax/utils';
const SVG = /*#__PURE__*/React.forwardRef((_ref, ref) => {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none",
    viewBox: "0 0 24 24",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M9.312 6H5.5a.5.5 0 0 0-.5.5V16h14V6.5a.5.5 0 0 0-.5-.5h-3.812l-.71.626a1.5 1.5 0 0 1-.992.374h-1.972a1.5 1.5 0 0 1-.991-.374zm5.21-1H18.5A1.5 1.5 0 0 1 20 6.5V16h2.496c.58 0 .822.74.355 1.084l-2.21 1.625a1.5 1.5 0 0 1-.889.291H4.33a1.5 1.5 0 0 1-.893-.294l-2.19-1.623C.781 16.738 1.024 16 1.603 16H4V6.5A1.5 1.5 0 0 1 5.5 5h9.021M2.815 17l1.217.902A.5.5 0 0 0 4.33 18h15.422a.5.5 0 0 0 .297-.097l1.227-.902z",
    clipRule: "evenodd"
  })));
});
const SvgDeviceNotebook = (_ref2, ref) => {
  let {
      title,
      titleId
    } = _ref2,
    props = _objectWithoutProperties(_ref2, _excluded2);
  const {
      className = '',
      color,
      size,
      pointer
    } = props,
    restProps = _objectWithoutProperties(props, _excluded3);
  const isClient = hooks.useOnlyClientRendering();
  const colorClassNameMod = color ? 'am-icon_color-' + color : '';
  const sizeClassNameMod = size ? 'am-icon_size-' + size : '';
  const poinerClassNameMod = pointer ? 'am-icon_pointer' : '';
  const classNames = [className, 'am-icon', colorClassNameMod, sizeClassNameMod, poinerClassNameMod].join(' ');
  if (!isClient) return null;
  return /*#__PURE__*/React.createElement(SVG, _extends({
    className: classNames
  }, restProps));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgDeviceNotebook);
const Memo = /*#__PURE__*/memo(ForwardRef);
export { Memo as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZmlsbC1ydWxlPSJldmVub2RkIiBjbGlwLXJ1bGU9ImV2ZW5vZGQiIGQ9Ik05LjMxMTg0IDYuMDAwNDZINS41MDAzM0M1LjIyNDE5IDYuMDAwNDYgNS4wMDAzMyA2LjIyNDMyIDUuMDAwMzMgNi41MDA0NlYxNi4wMDA1SDE5LjAwMDNWNi41MDA0NkMxOS4wMDAzIDYuMjI0MzIgMTguNzc2NSA2LjAwMDQ2IDE4LjUwMDMgNi4wMDA0NkgxNC42ODgyTDEzLjk3NzIgNi42MjYwOEMxMy43MDM0IDYuODY3MDcgMTMuMzUxMSA3LjAwMDAxIDEyLjk4NjMgNy4wMDAwMUgxMS4wMTM3QzEwLjY0ODkgNy4wMDAwMSAxMC4yOTY2IDYuODY3MDcgMTAuMDIyOCA2LjYyNjA4TDkuMzExODQgNi4wMDA0NlpNMTQuNTIxMyA1LjAwMDQ2SDE4LjUwMDNDMTkuMzI4OCA1LjAwMDQ2IDIwLjAwMDMgNS42NzIwMyAyMC4wMDAzIDYuNTAwNDZWMTYuMDAwNUwyMi40OTU4IDE2LjAwMDVDMjMuMDc1MyAxNi4wMDA1IDIzLjMxODEgMTYuNzQwNiAyMi44NTEyIDE3LjA4MzlMMjAuNjQwOCAxOC43MDlDMjAuMzgzMyAxOC44OTgzIDIwLjA3MTkgMTkuMDAwNSAxOS43NTIzIDE5LjAwMDVINC4zMzAzOUM0LjAwODg2IDE5LjAwMDUgMy42OTU4NCAxOC44OTcxIDMuNDM3NDkgMTguNzA1N0wxLjI0NjQ0IDE3LjA4MjZDMC43ODE2NzYgMTYuNzM4MyAxLjAyNTIgMTYuMDAwNSAxLjYwMzYgMTYuMDAwNUw0LjAwMDMzIDE2LjAwMDVWNi41MDA0NkM0LjAwMDMzIDUuNjcyMDMgNC42NzE5IDUuMDAwNDYgNS41MDAzMyA1LjAwMDQ2SDkuNDc4NzNDOS40OTMwMiA0Ljk5OTg1IDkuNTA3MzQgNC45OTk4NSA5LjUyMTY1IDUuMDAwNDZIMTQuNDc4M0MxNC40OTI3IDQuOTk5ODUgMTQuNTA3IDQuOTk5ODUgMTQuNTIxMyA1LjAwMDQ2Wk0yLjgxNTUxIDE3LjAwMDVMNC4wMzI3NSAxNy45MDIyQzQuMTE4ODcgMTcuOTY2IDQuMjIzMjEgMTguMDAwNSA0LjMzMDM5IDE4LjAwMDVIMTkuNzUyM0MxOS44NTg4IDE4LjAwMDUgMTkuOTYyNiAxNy45NjY0IDIwLjA0ODUgMTcuOTAzM0wyMS4yNzY1IDE3LjAwMDVIMi44MTU1MVoiIGZpbGw9ImN1cnJlbnRDb2xvciIvPgo8L3N2Zz4K";